import { Lock } from 'lucide-react'
import { InfoTooltip } from '@/components/InfoTooltip'
import { Tooltip } from '@/components/Tooltip'
import type { OrchestrationStep } from '@/types/bundle'
import { ORCHESTRATION_STEP_DESCRIPTIONS } from '../labels'

export interface OrchestrationStepsSectionProps {
  steps: OrchestrationStep[]
}

// Read-only ordered list - no input elements or drag handles at all (PRD 02
// AC2), not just visually greyed. Lock icon + tooltip, matching PRD 00's
// "never disabled with no explanation" states rule.
export function OrchestrationStepsSection({ steps }: OrchestrationStepsSectionProps) {
  return (
    <section className="flex flex-col gap-3 rounded-control border border-border bg-surface p-4">
      <div className="flex items-center gap-2">
        <h2 className="text-header font-semibold text-text-primary">Orchestration steps</h2>
        <Tooltip text="Shows the fixed order every request is processed in, from validating the request through to building the response. Contact your developer to change processing order.">
          <span tabIndex={0} className="text-text-disabled">
            <Lock size={14} strokeWidth={1.5} />
          </span>
        </Tooltip>
      </div>
      <ol className="flex flex-col gap-1">
        {steps.map((step, index) => (
          <li
            key={`${step.engine}-${index}`}
            className="flex items-center gap-2 rounded-control bg-surface-raised px-3 py-2 text-body text-text-disabled"
          >
            <span className="text-meta text-text-secondary">{index + 1}.</span>
            {step.engine}
            {ORCHESTRATION_STEP_DESCRIPTIONS[step.engine] && (
              <InfoTooltip text={ORCHESTRATION_STEP_DESCRIPTIONS[step.engine]} />
            )}
          </li>
        ))}
      </ol>
    </section>
  )
}
